/* eslint-disable */
export default {
  hide: 'Ocultar',
  end: 'Encerrar',
  keypad: 'Teclado numérico',
} as const;

// @key: @#@"hide"@#@ @source: @#@"Hide"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
